<template>
    <div class="grid md:grid-cols-2 items-center gap-2 md:gap-0">
        <h1 class="text-dark font-bold text-xl">
            Overall user rating
        </h1>

        <div class="md:text-right">
            <ReviewStarRating :modelValue="rating" size="1x" spacing="space-x-2"></ReviewStarRating>
        </div>

        <p class="text-dark mb-4 md:col-span-2">{{ formatReviewCount }} reviews</p>
    </div>
</template>

<script>
import ReviewStarRating from "@/Components/Reviews/ReviewStarRating";

export default {
    components: {ReviewStarRating},
    name: "OverallUserRating",
    props: {
        reviewCount: [Number, String],
        rating: [Number, String]
    },
    computed: {
        formatReviewCount() {
            return this.reviewCount.toLocaleString();
        }
    }
};
</script>

<style scoped>

</style>
